import { IconArrowLeft, IconArrowRight } from '@tabler/icons-react';
import { useGenerateSupplierRequestMutation } from '../../../api';
import { LDFeatureFlags, useLDFeatureFlag } from '../../../hooks';
import { Button } from '../../../ui';
import { useSupplierRequestWizardContext } from './context';

export const Requirements = () => {
  const {
    supplierRequestInput,
    setCurrentStep,
    handleChangeValue,
    setFlow,
    saveDraftLoading,
    saveSupplierRequestDraft,
  } = useSupplierRequestWizardContext();
  const { description } = supplierRequestInput;
  const [
    generateSupplierRequest,
    { isLoading: isGenerateSupplierRequestLoading },
  ] = useGenerateSupplierRequestMutation();

  const handleContinue = async () => {
    try {
      const result = await generateSupplierRequest(description).unwrap();
      if (result) {
        handleChangeValue('projectName', result.projectName || '');
        handleChangeValue('timeframe', result.timeframe || '');
        handleChangeValue('locations', result.locations || '');
        handleChangeValue('budget', result.budget || '');
        handleChangeValue('unitVolume', result.unitVolume || '');
        handleChangeValue('subCategory', result.subCategory || '');
        handleChangeValue('category', result.category || '');
      }
      setCurrentStep('PREFERENCES');
      setFlow('wizard');
    } catch (err) {
      setCurrentStep('PREFERENCES');
      setFlow('wizard');
    }
  };

  return (
    <div className="flex flex-col gap-4 flex-1 px-32">
      <div className="flex flex-col gap-2">
        <span className="text-2xl font-bold">Purchasing Requirements</span>
        <span className="text-base font-normal">
          Please copy and paste your purchasing requirements from your internal
          procurement documents, RFPs, or supplier communications. This should
          include detailed information such as product specifications,
          quantities, delivery timelines, and any other relevant terms.
        </span>
      </div>
      <textarea
        className="rounded-2xl bg-gray-100 resize-none p-3 sm:min-h-[150px] md:min-h-[250px] lg:min-h-[375px]"
        placeholder="Enter Text..."
        value={description}
        onChange={(e) => handleChangeValue('description', e.target.value)}
      ></textarea>
      <div className="flex justify-between pt-8">
        <div>
          <Button
            text="Back"
            variant="secondary"
            loading={isGenerateSupplierRequestLoading}
            prefixIcon={<IconArrowLeft />}
            onClick={() => setCurrentStep('INITIAL')}
          />
        </div>

        <div className="flex gap-4">
          {useLDFeatureFlag(
            LDFeatureFlags.SUPPLIER_REQUEST_SAVE_AS_DRAFT,
            false
          ) && (
            <Button
              text="Save as Draft"
              loading={saveDraftLoading}
              prefixIcon="/icons/draft.svg"
              variant={'secondary'}
              theme="light"
              onClick={saveSupplierRequestDraft}
            />
          )}

          <Button
            text="Continue"
            variant={description ? 'primary' : 'disabled'}
            loading={isGenerateSupplierRequestLoading}
            suffixIcon={<IconArrowRight />}
            onClick={handleContinue}
          />
        </div>
      </div>
    </div>
  );
};
